export default function getWordPressConnectUrl(wpAdminUrl, nonce, authorizationParams) {
  const connectParams = Object.assign({
    leadin_connect: nonce
  }, authorizationParams);
  return Object.entries(connectParams).reduce((url, [key, value]) => `${url}&${encodeURIComponent(key)}=${encodeURIComponent(value)}`, `${wpAdminUrl}admin.php?page=leadin`);
}